import React, { useCallback } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TagDragArea, TAG_AREA_ID_LEFT, TAG_AREA_ID_RIGHT } from './tag-drag-area'

import styles from './tag-drag.module.css'

const propTypes = {
    leftItems: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired
        })
    ).isRequired,
    leftTitle: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    rightItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired
        })
    ).isRequired,
    rightTitle: PropTypes.string,
    tagClassName: PropTypes.string
}

const TagDrag = ({ className, leftItems, leftTitle, onChange, onDelete, rightItems, rightTitle, tagClassName }) => {
    const onChangeLeft = useCallback(
        function (item) {
            onChange(item, TAG_AREA_ID_LEFT)
        },
        [onChange]
    )
    const onChangeRight = useCallback(
        function (item) {
            onChange(item, TAG_AREA_ID_RIGHT)
        },
        [onChange]
    )

    return (
        <DndProvider backend={HTML5Backend}>
            <div className={cx(styles['tag-drag-wrapper'], className)}>
                <TagDragArea
                    areaId={TAG_AREA_ID_LEFT}
                    title={leftTitle}
                    items={leftItems}
                    className={styles['tag-area-left']}
                    onDrop={onChangeLeft}
                    onClick={onChangeRight}
                    {...{ onDelete, tagClassName }}
                />
                <TagDragArea
                    areaId={TAG_AREA_ID_RIGHT}
                    items={rightItems}
                    title={rightTitle}
                    onDrop={onChangeRight}
                    onClick={onChangeLeft}
                    {...{ onDelete, tagClassName }}
                />
            </div>
        </DndProvider>
    )
}

TagDrag.propTypes = propTypes
export { TagDrag, TAG_AREA_ID_RIGHT, TAG_AREA_ID_LEFT }
